export const contractReviewerConstants = {

    DESELECT_DOCUMENT: 'DESELECT_DOCUMENT',

    GET_DOCUMENTS_LIST_REQUEST: 'GET_DOCUMENTS_LIST_REQUEST',
    GET_DOCUMENTS_LIST_SUCCESS: 'GET_DOCUMENTS_LIST_SUCCESS',
    GET_DOCUMENTS_LIST_FAILURE: 'GET_DOCUMENTS_LIST_FAILURE',

    GET_TEMPLATE_DOCUMENTS_LIST_REQUEST: 'GET_TEMPLATE_DOCUMENTS_LIST_REQUEST',
    GET_TEMPLATE_DOCUMENTS_LIST_SUCCESS: 'GET_TEMPLATE_DOCUMENTS_LIST_SUCCESS',
    GET_TEMPLATE_DOCUMENTS_LIST_FAILURE: 'GET_TEMPLATE_DOCUMENTS_LIST_FAILURE',

    GET_DOCUMENT_ANALYSIS_REQUEST: 'GET_DOCUMENT_ANALYSIS_REQUEST',
    GET_DOCUMENT_ANALYSIS_SUCCESS: 'GET_DOCUMENT_ANALYSIS_SUCCESS',
    GET_DOCUMENT_ANALYSIS_PENDING: 'GET_DOCUMENT_ANALYSIS_PENDING',
    GET_DOCUMENT_ANALYSIS_FAILURE: 'GET_DOCUMENT_ANALYSIS_FAILURE',

    GET_COMPARISON_DOCUMENT_ANALYSIS_REQUEST: 'GET_COMPARISON_DOCUMENT_ANALYSIS_REQUEST',
    GET_COMPARISON_DOCUMENT_ANALYSIS_SUCCESS: 'GET_COMPARISON_DOCUMENT_ANALYSIS_SUCCESS',
    GET_COMPARISON_DOCUMENT_ANALYSIS_FAILURE: 'GET_COMPARISON_DOCUMENT_ANALYSIS_FAILURE',

    GET_DOCUMENT_SEGMENTS_REQUEST: 'GET_DOCUMENT_SEGMENTS_REQUEST',
    GET_DOCUMENT_SEGMENTS_SUCCESS: 'GET_DOCUMENT_SEGMENTS_SUCCESS',
    GET_DOCUMENT_SEGMENTS_FAILURE: 'GET_DOCUMENT_SEGMENTS_FAILURE',

    START_UPLOAD_SINGLE: 'START_UPLOAD_SINGLE',
    FINISH_UPLOAD_SINGLE: 'FINISH_UPLOAD_SINGLE',
    START_UPLOAD_MULTIPLE: 'START_UPLOAD_MULTIPLE',
    UPDATE_UPLOAD_MULTIPLE: 'UPDATE_UPLOAD_MULTIPLE',
    FINISH_UPLOAD_MULTIPLE: 'FINISH_UPLOAD_MULTIPLE',
    RESET_UPLOAD_STATE: 'RESET_UPLOAD_STATE',
    FAILED_UPLOAD: 'FAILED_UPLOAD',

    PROCESS_DOCUMENT_REQUEST: 'PROCESS_DOCUMENT_REQUEST',
    PROCESS_DOCUMENT_SUCCESS: 'PROCESS_DOCUMENT_SUCCESS',
    PROCESS_DOCUMENT_FAILURE: 'PROCESS_DOCUMENT_FAILURE',

    EDIT_DOCUMENT_TYPE_REQUEST: 'EDIT_DOCUMENT_TYPE_REQUEST',
    EDIT_DOCUMENT_TYPE_SUCCESS: 'EDIT_DOCUMENT_TYPE_SUCCESS',
    EDIT_DOCUMENT_TYPE_FAILURE: 'EDIT_DOCUMENT_TYPE_FAILURE',

    DOWNLOAD_DOCUMENT_REQUEST: 'DOWNLOAD_DOCUMENT_REQUEST',
    DOWNLOAD_DOCUMENT_SUCCESS: 'DOWNLOAD_DOCUMENT_SUCCESS',
    DOWNLOAD_DOCUMENT_FAILURE: 'DOWNLOAD_DOCUMENT_FAILURE',

    DELETE_DOCUMENT_REQUEST: 'DELETE_DOCUMENT_REQUEST',
    DELETE_DOCUMENT_SUCCESS: 'DELETE_DOCUMENT_SUCCESS',
    DELETE_DOCUMENT_FAILURE: 'DELETE_DOCUMENT_FAILURE',

    ADD_TEXT_SEGMENT_REQUEST: 'ADD_TEXT_SEGMENT_REQUEST',
    ADD_TEXT_SEGMENT_SUCCESS: 'ADD_TEXT_SEGMENT_SUCCESS',
    ADD_TEXT_SEGMENT_FAILURE: 'ADD_TEXT_SEGMENT_FAILURE',

    DELETE_TEXT_SEGMENT_REQUEST: 'DELETE_TEXT_SEGMENT_REQUEST',
    DELETE_TEXT_SEGMENT_SUCCESS: 'DELETE_TEXT_SEGMENT_SUCCESS',
    DELETE_TEXT_SEGMENT_FAILURE: 'DELETE_TEXT_SEGMENT_FAILURE',

    EDIT_HIGHLIGHT_NOTES_REQUEST: 'EDIT_HIGHLIGHT_NOTES_REQUEST',
    EDIT_HIGHLIGHT_NOTES_SUCCESS: 'EDIT_HIGHLIGHT_NOTES_SUCCESS',
    EDIT_HIGHLIGHT_NOTES_FAILURE: 'EDIT_HIGHLIGHT_NOTES_FAILURE',

    EDIT_HIGHLIGHT_IS_SELECTED_REQUEST: 'EDIT_HIGHLIGHT_IS_SELECTED_REQUEST',
    EDIT_HIGHLIGHT_IS_SELECTED_SUCCESS: 'EDIT_HIGHLIGHT_IS_SELECTED_SUCCESS',
    EDIT_HIGHLIGHT_IS_SELECTED_FAILURE: 'EDIT_HIGHLIGHT_IS_SELECTED_FAILURE',

    COMPARE_DOCUMENTS_REQUEST: 'COMPARE_DOCUMENTS_REQUEST',
    COMPARE_DOCUMENTS_SUCCESS: 'COMPARE_DOCUMENTS_SUCCESS',
    COMPARE_DOCUMENTS_FAILURE: 'COMPARE_DOCUMENTS_FAILURE',

    EXPORT_AS_DOCX_REQUEST: 'EXPORT_AS_DOCX_REQUEST',
    EXPORT_AS_DOCX_SUCCESS: 'EXPORT_AS_DOCX_SUCCESS',
    EXPORT_AS_DOCX_FAILURE: 'EXPORT_AS_DOCX_FAILURE',

    EXPORT_AS_EXCEL_REQUEST: 'EXPORT_AS_EXCEL_REQUEST',
    EXPORT_AS_EXCEL_SUCCESS: 'EXPORT_AS_EXCEL_SUCCESS',
    EXPORT_AS_EXCEL_FAILURE: 'EXPORT_AS_EXCEL_FAILURE',

    GET_DOCUMENT_SUMMARY_REQUEST: 'GET_DOCUMENT_SUMMARY_REQUEST',
    GET_DOCUMENT_SUMMARY_SUCCESS: 'GET_DOCUMENT_SUMMARY_SUCCESS',
    GET_DOCUMENT_SUMMARY_FAILURE: 'GET_DOCUMENT_SUMMARY_FAILURE'
};


// WEBPACK FOOTER //
// ./src/constants/contractReviewer.constants.js